import { createAsyncThunk } from "@reduxjs/toolkit";
import config from '../../config.js'

const API_URL = config.API_URL; // URL da API

// Thunk para buscar usuários
export const fetchUsers = createAsyncThunk("users/fetchUsers", async () => {
    const response = await fetch(`${API_URL}/user/users`);
    if (!response.ok) throw new Error("Erro ao buscar usuários");
    return response.json();
});

// Thunk para criar o User chamando a API
export const createUser = createAsyncThunk(
    "users/createUser",
    async ({ userName, userEmail, userPassword, isAdmin, approved, selectedDashboardsFilter, selectedGroups }, { rejectWithValue }) => {
        try {
            const response = await fetch(`${API_URL}/user/user`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ userName, userEmail, userPassword, isAdmin, approved, selectedDashboardsFilter, selectedGroups }),
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || "Erro ao salvar User");

            return data; // Retorna os dados salvos para o Redux
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Thunk para atualizar um usuário existente
export const updateUser = createAsyncThunk(
    "users/updateUser",
    async ({ id, userName, userEmail, isAdmin, approved, selectedDashboards, selectedGroups }, { rejectWithValue }) => {
        try {
            const response = await fetch(`${API_URL}/user/user/${id}`, {
                method: "PUT", // Ou PATCH, dependendo da sua API
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ userName, userEmail, isAdmin, approved, selectedDashboards, selectedGroups }),
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || "Erro ao atualizar User");

            return data; // Retorna os dados atualizados para o Redux
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Thunk para deletar um usuário
export const deleteUser = createAsyncThunk(
    "users/deleteUser",
    async (uid, { rejectWithValue }) => {
        try {
            const response = await fetch(`${API_URL}/user/user/${uid}`, {
                method: "DELETE",
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || "Erro ao deletar usuário");

            return uid; // Retorna apenas o UID deletado para o reducer remover da lista
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);